module.exports = __webpack_public_path__ + "media/img/skrzynia-automatyczna@3x-596dd8f9.svg";